class GlobalLockManager {
  constructor() {
    this.locks = new Map()
  }

  lock(key) {
    this.locks.set(key, true)
  }

  unlock(key) {
    this.locks.set(key, false)
  }

  isLocked(key) {
    return this.locks.get(key) ?? false
  }

  toggle(key) {
    const current = this.isLocked(key)
    this.locks.set(key, !current)
  }

  clearAll() {
    this.locks.clear()
  }
}

export const globalLockManager = new GlobalLockManager()

// singleton Global-Lock-Manger ( naive implementation to allow locking and unlocking of resources like indexedDB)
